import { Component, Mixins } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({})
export default class Success extends Mixins<MixinInterface>() {
    get username() {
        return this.$route.query?.username ? this.$route.query.username : null
    }

    get type() {
        return this.$route.name ? this.$route.name.split('-').join('_') : 'success'
    }
}
